<div class="wrpr">
    <div class="contentCard">
        <div class="flexSP">
            <div class="pageName">
                <img src="../../../../assets/images/Manage_Modules_Icon_black.svg" alt="manage-users-icon" style="width: auto; height: 27px;">
                <h1>Manage Modules</h1>
            </div>
            <button *ngIf="false" class="primary" (click)="createModuleStart_Popup()">Create Module</button>
        </div>
        <!-- <div class="announcementCont dontShow">
            <div class="leftblock">
                <img src="../../../../assets/images/dmint-ui-kit-foundation-icons-failed-message-filled.svg" alt="">
                <p><span>{{getRejectedRequestsCount()}} requests</span> waiting for you to take action.</p>
            </div>
            <a href="http://">
                <img src="../../../../assets/images/Cross.svg" alt="">
            </a>
        </div> -->
        <div class="filtersCont new">
            <div class="nameAndIcon" (click)="toggleFiltersCont()">
                <img src="/assets/images/newFiltersIcon.svg" alt="" />
                <h4>
                    Filters
                     <span *ngIf="getSelectedFilterCount() > 0">({{getSelectedFilterCount()}} selected)
                    </span>
                </h4>

                <hr class="vertical" *ngIf="getSelectedFilterCount() > 0">

                <a (click)="resetAllFilters()" class="dmintLinkBtn red" style="margin-top: 5px; padding: 0;" *ngIf="getSelectedFilterCount() > 0">
                    Reset all
                </a>
            <img style="margin-left: auto;" class="" src="/assets/images/chevron-south.svg" alt=""/>
            </div>
            <div class="filtersBox" *ngIf="isFilterOpen">
                <form class="filtersBox" [formGroup]="dataRequestForm">
                    <div class="filterType">
                        <div class="formControl">
                             <input
                                id="searchTerm"
                                name="searchTerm"
                                type="text"
                                [(ngModel)]="searchTerm"
                                [ngModelOptions]="{standalone: true}"
                               (keyup.enter)="onSearchChange()"
                                placeholder="Search..."
                                class="searchField"
                            />
                             <button type="button" *ngIf="searchTerm" class="clear-btn" (click)="searchTerm=''; onAdvancedFilter()">
                            &#x2715;
                        </button>
                        </div>
                        <div class="formControl">
                            <!-- <app-lib-multi-select
                                [labelText]="'Category'"
                                [noLabel]="false"
                                [isReq]="false"
                                [options]="categoryOptions"
                                [selectedItems]="selectedCategory()"
                                [isDropdownOpen]="openDropdownKey === 'category'"
                                (toggleDropdown)="onMultiSelectDropdownToggle('category')"
                                (selectionChange)="onCategorySelectionChange($event)"
                                >
                            </app-lib-multi-select> -->
                            <label for="Category" class="label">Module Header</label>
                            <ng-multiselect-dropdown style="width: 100%;"
                                [placeholder]="'Select'"
                                [settings]="categoryTypeFilterDropdownSettings"
                                formControlName="categoryType"
                                [data]="categoryOptions"
                                (onSelect)="onCategorySelect($event)"
                                (onDeSelect)="onCategoryDeselect($event)"
                                (onSelectAll)="onSelectAllCategoryTypes($event)"
                                (onDeSelectAll)="onDeSelectAllCategoryTypes($event)"
                                >
                            </ng-multiselect-dropdown>
                        </div>
                        <div class="formControl">
                            <label for="updatedOn" class="label">Updated on</label>
                            <!-- <input 
                                type="date" 
                                id="updatedOn" 
                                formControlName="updatedOn" 
                                class="inputField"
                                style="
                                    margin-top: 5px; width: 100%; height: 3.5rem; font-size: 1rem; line-height: 1.5; padding: .938rem 1rem; position: relative; display: flex; align-items: center; justify-content: space-between; background: #fff; border-radius: .25rem; border: 1px solid #F5F5F5; box-shadow: 0 0 14px #00000026;"
                                /> -->
                                 <mat-form-field>
                                    <mat-date-range-input [formGroup]="updatedOn" [rangePicker]="picker2"  [max]="maxDate">
                                        <input readonly matStartDate formControlName="startDate" placeholder="Start Date">
                                        <input readonly matEndDate formControlName="endDate" placeholder="End Date"
                                        (dateChange)="onDateSelected()" >
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker2></mat-date-range-picker>
                                </mat-form-field>
                                <div *ngIf="updatedOn.errors?.['endBeforeStart']" class="error">
                                    End date cannot be before start date.
                                </div>
                        </div>
                        <div class="formControl">
                            <!-- <app-lib-multi-select
                                [labelText]="'Status'"
                                [noLabel]="false"
                                [isReq]="false"
                                [options]="statusOptions"
                                [selectedItems]="selectedStatus()"
                                [isDropdownOpen]="openDropdownKey === 'status'"
                                (toggleDropdown)="onMultiSelectDropdownToggle('status')"
                                (selectionChange)="onStatusSelectionChange($event)"
                                >
                            </app-lib-multi-select> -->
                             <label for="Status" class="label">Status</label>
                            <ng-multiselect-dropdown style="width: 100%;"
                                [placeholder]="'Select'"
                                [settings]="statusFilterDropdownSettings"
                                formControlName="statusType"
                                [data]="statusOptions"
                                (onSelect)="onStatusSelect($event)"
                                (onDeSelect)="onStatusDeselect($event)"
                                (onSelectAll)="onSelectAllStatusTypes($event)"
                                (onDeSelectAll)="onDeSelectAllStatusTypes($event)"
                                >
                            </ng-multiselect-dropdown>
                        </div>
                    </div>
                </form>
            </div>
        </div>
         <div class="kpiCont">
                <p *ngIf="filterData?.length>0">
                Showing {{ (page - 1) * itemsPerPage + 1 }} -
                {{ page * itemsPerPage < totalItems ? page * itemsPerPage : totalItems }} of
                {{ totalItems }} results
            </p>
            <p *ngIf="filterData?.length==0">Showing 0 of 0 results</p>
        </div>

        <div class="tableCont">
            <div class="table" *ngIf="filterData?.length>0">
                <div class="tHead">
                    <!-- <div class="tCol">
                        Module Type
                    </div>
                    <div class="tCol">
                        Module Name
                    </div>
                    <div class="tCol">
                        Updated By
                    </div>
                    <div class="tCol">
                        Updated on
                    </div>
                    <div class="tCol">
                        Status
                    </div>
                    <div class="tCol">
                        Actions
                    </div> -->
                <div class="tCol"  *ngFor="let column of columns;let i=index" >
                        {{column}}
                        <span *ngIf="(column == 'Updated On')"
                            class="down-arrow-icon" (click)="onSort(column,i)" onKeyPress=""
                            [class.rotate]="isAscending">
                            <img src="../../../assets/images/chevron-down.svg" alt="chevron_icon" /></span>
                    </div>
                </div>
                <div class="tRow"*ngFor="let item of filterData | paginate
                  : {
                      id: 'listing_pagination',
                      itemsPerPage: itemsPerPage,
                      currentPage: page,
                      totalItems: totalItems
                    }">
                    <div class="tCol">
                        <span class="truncateText">
                            {{item.moduleHeader}}
                        </span> 
                    </div>
                    <div class="tCol">
                        <span class="truncateText">
                            {{item.moduleType}}
                        </span> 
                    </div>
                    <div class="tCol">
                        <span class="truncateText">
                            {{item.moduleName}}
                        </span> 
                    </div>
                    <div class="tCol">
                        <span class="truncateEmail">
                            {{item.updatedBy}}
                        </span>
                        <!-- <span class="userEmail">
                            <span class="truncateEmail">
                                {{item.submittedByEmail}} 
                            </span>
                            <span class="copyIconWrapper" 
                                  (mouseenter)="showCopyTooltip(item.moduleOwnerEmail, $event)"
                                  (mouseleave)="hideCopyTooltip()"
                                  (click)="copyEmailToClipboard(item.moduleOwnerEmail, $event)">
                                <img src="../../../../assets/images/copyIcon.svg" alt="Copy-Email" style="cursor: pointer;">
                                <span class="copyTooltip" 
                                      *ngIf="showTooltip && tooltipEmail === item.moduleOwnerEmail">
                                    {{tooltipMessage}}
                                </span>
                            </span>
                        </span> -->
                    </div>
                    <div class="tCol">
                        {{item.updatedDate}}
                    </div>
                    <div class="tCol">
                        <span class="statusPill"
                        [ngClass]="
                            item.statusName === 'Active'
                            ? 'completed_chip'
                            : item.statusName === 'Inactive'
                            ? 'failed_chip'
                            : ''
                        "
                        >{{item.statusName}}</span>
                    </div>
                    <div class="tCol">
                        <button class="dmintLinkBtn"
                        [ngClass]="
                            item.statusName === 'Active'
                            ? 'completed_chip'
                            : item.statusName === 'Inactive'
                            ? 'failed_chip'
                            : ''
                        "
                        (click)="openRequestDetailsPopup(item)" [disabled]="true"
                        >
                            <img src="{{editIconBtn}}" alt="">
                            View/Edit 
                        </button>
                    </div>
                </div>
            </div>
            <!-- <div class="pagination">
                <button (click)="getPage(currentPage - 1)" [disabled]="currentPage === 1">Prev</button>
                <button *ngFor="let page of getPageNumbers()" [ngClass]="{active: page === currentPage}" (click)="getPage(page)">
                    {{page}}
                </button>
                <button (click)="getPage(currentPage + 1)" [disabled]="currentPage === getPageNumbers().length">Next</button>
            </div> -->
             <div class="paginationCont" *ngIf="filterData?.length > 0">
              <pagination-controls id="listing_pagination"
                    (pageChange)="getPage($event)"
                    [maxSize]="5" 
                    previousLabel="Prev"
                    nextLabel="Next">
                </pagination-controls>
            </div>
        </div>
         <ng-container *ngIf="filterData?.length === 0">
        <div class="noResults">
            <img src="/assets/images/noResults.png" alt="no-results" />
            <p>No results found.</p>
        </div>
      </ng-container>
    </div>
    <!--
    <div class="popupCont" *ngIf="isPopupOpen" (click)="closePopup()">
        <div class="popupModal" (click)="$event.stopPropagation()">
            <div class="popupHeader">
                <h2
                style="display: inline-flex; align-items: center; gap: 16px;">Access Request Details 
                    <span *ngIf="selectedRequest.status !== 'Pending' && selectedRequest.status === 'Approved'" class="statusPill completed_chip">Approved</span>
                    <span *ngIf="selectedRequest.status !== 'Pending' && selectedRequest.status === 'Rejected'" class="statusPill failed_chip">Rejected</span>
                </h2>
                <img src="../../../../assets/images/closeIcon-16x16.svg" alt="Close" (click)="closePopup()" style="cursor: pointer;">
            </div>
            <div class="scrollB">
                <div class="metadataCont" *ngIf="hasMetadata()">
                    <div class="metadataItem" *ngFor="let key of getMetadataKeys()">
                        <span class="metadataLabel">{{ key }}:</span>
                        <span class="metadataValue">{{ metadata[key] }}</span>
                    </div>
                </div>
                <div class="RequestedUG" [ngClass]="{'orderOne': selectedRequest.status === 'Approved'}">
                    <h3>Requested User Groups <span>{{allUserGroupOptions.length}} selected</span></h3>
                    <div class="availableOptions">
                        <div class="optionsContainer" *ngIf="selectedRequest.status ==='Pending'">
                            <button 
                                *ngFor="let option of allUserGroupOptions"
                                class="optionChip"
                                [class.selected]="isUserGroupSelected(option)"
                                (click)="toggleUserGroup(option)">
                                {{ option }}
                                <span *ngIf="isUserGroupSelected(option)" class="removeIcon">×</span>
                            </button>
                        </div>
                        <div class="optionsContainer" *ngIf="selectedRequest.status !=='Pending'">
                            <button 
                                *ngFor="let option of allUserGroupOptions"
                                class="optionChip selected"
                                >
                                {{ option }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="availableSubs" *ngIf="selectedRequest.status !== 'Rejected'">
                    <div class="subsHeader">
                        <p class="note" *ngIf="selectedRequest.status !=='Pending'">Subscription Name</p>
                        <p class="note" *ngIf="selectedRequest.status ==='Pending'">Select Subscription for the user</p>
                        <button class="secondary" *ngIf="selectedRequest.status == 'Pending' && !isCreatingNewSubscription" (click)="createNewSubscription()">Create new subscription</button>
                    </div>
                    
                    <!-- New subscription creation form 
                    <div class="newSubscriptionForm" *ngIf="isCreatingNewSubscription">
                        <div class="formRow">
                            <label for="subName">Subscription Name:</label>
                            <input 
                                type="text" 
                                id="subName"
                                [(ngModel)]="newSubscriptionForm.name"
                                placeholder="Enter subscription name"
                                class="searchField" />
                        </div>
                        <div class="formRow">
                            <label for="subCreatedOn">Created On:</label>
                            <input 
                                type="date" 
                                id="subCreatedOn"
                                [(ngModel)]="newSubscriptionForm.createdOn"
                                class="searchField" />
                        </div>
                        <div class="formRow">
                            <label for="subExpiryDate">Expiry Date:</label>
                            <input 
                                type="date" 
                                id="subExpiryDate"
                                [(ngModel)]="newSubscriptionForm.expiryDate"
                                class="searchField" />
                        </div>
                        <div class="formActions">
                            <button class="doneBtn" (click)="saveNewSubscription()"><span class="check"></span></button>
                            <button class="cancelBtn" (click)="cancelNewSubscription()"><span class="cross"></span></button>
                        </div>
                    </div>

                    <div class="subsList" *ngIf="selectedRequest.status === 'Pending'">
                        <div class="subItem" *ngFor="let sub of availableSubscriptions">
                            <input 
                                type="radio" 
                                name="subscription" 
                                [value]="sub.id" 
                                [(ngModel)]="selectedRequest.selectedSubscriptionId"
                                (change)="onSubscriptionSelect(sub.id)" />
                            <div class="subDetails">
                                <span class="subName">{{ sub.name }}</span>
                                <span class="subInfo">({{ sub.createdOn | date: 'yyyy-MM-dd' }} - {{ sub.expiryDate | date: 'yyyy-MM-dd' }})</span>
                            </div>
                        </div>
                    </div>
                    <div class="subsList" *ngIf="selectedRequest.status !== 'Pending'">
                        <div class="subItem">
                            <div class="subDetails">
                                <span class="subName">DMINT Pro</span>
                                <span class="subInfo">(2024-11-12 - 2025-11-12)</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="formRow" [ngClass]="{'orderOne': selectedRequest.status === 'Approved'}">
                    <label for="notes" *ngIf="selectedRequest.status !=='Pending'">Additional Comments</label>
                    <p class="comment" *ngIf="selectedRequest.status !=='Pending'">Lorem ipsum dolor sit amet, consectetur psum dolor sit amet, consectetur adipiscing Lorem ipsum dolor sit amet, consectetur adipiscing Lorem ipsum dolor sit amet, consectetur adipiscing.</p>
                    <label for="notes" *ngIf="selectedRequest.status ==='Pending'">Please provide comment for the Approve/Reject</label>
                    <textarea id="notes" *ngIf="selectedRequest.status ==='Pending'" [(ngModel)]="selectedRequest.notes" rows="1" class="notesField"></textarea>
                </div>
            </div>
            <div class="ctaCont" [ngClass]="{'orderOne': selectedRequest.status === 'Approved'}">
                <button class="primary red" *ngIf="selectedRequest.status == 'Pending'" (click)="rejectRequest()">Reject</button>
                <button class="primary" *ngIf="selectedRequest.status == 'Pending'" (click)="acceptRequest()">Approve</button>
                <button class="dmintLinkBtn completed_chip" *ngIf="selectedRequest.status == 'Approved' || selectedRequest.status == 'Rejected'" (click)="closePopup()">Close</button>
            </div>
        </div>
    </div> -->

    <!-- Create Module Modal -->
    <div class="popupCont" *ngIf="isCreateModuleModalOpen" (click)="closeCreateModuleModal()">
        <div class="popupModal createModuleModal" (click)="$event.stopPropagation()">
            <div class="popupHeader">
                <h2>Select a Module Type to begin</h2>
                <img src="../../../../assets/images/closeIcon-16x16.svg" alt="Close" (click)="closeCreateModuleModal()" style="cursor: pointer;">
            </div>
            <div class="moduleTypeOptions">
                <div 
                    class="moduleTypeCard" 
                    *ngFor="let option of moduleTypeOptionsForCreate"
                    [class.selected]="selectedModuleTypeForCreate === option.name"
                    (click)="selectModuleTypeForCreate(option.name)">
                    <img [src]="option.icon" alt="{{option.name}}" class="moduleTypeIcon">
                    <span class="moduleTypeName">{{option.name}}</span>
                </div>
            </div>
            <div class="ctaCont">
                <button class="primary" (click)="confirmCreateModule()">Continue</button>
            </div>
        </div>
    </div>
</div>
<app-success-toast [message]="successMessage" *ngIf="successMessage"></app-success-toast>
<app-error-toast *ngIf="error" [message]="error"></app-error-toast>
<app-alert [message]="errMsg" *ngIf="showErrorMessageWithPopup" (close)="onCloseHandlerSub()"></app-alert>